import { combineReducers, configureStore } from "@reduxjs/toolkit";
import messageReducer from "./slices/message";
import loggerReducer from "./slices/logger";
import hiringSlice from "./slices/hiring";
import applicationsSlice from "./slices/application";
import querySlice from "./slices/query";
import authSlice from "./slices/auth";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import { hiringApi } from "./services/hiring";
import { userApi } from "./services/users";
import { applicationsApi } from "./services/applications";
import { coursesApi } from "./services/course";

const reducers = combineReducers({
  message: messageReducer,
  logger: loggerReducer,
  hiring: hiringSlice,
  applications: applicationsSlice,
  query: querySlice,
  auth: authSlice,
  [hiringApi.reducerPath]: hiringApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [applicationsApi.reducerPath]: applicationsApi.reducer,
  [coursesApi.reducerPath]: coursesApi.reducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"], // only auth will be persisted
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      hiringApi.middleware,
      userApi.middleware,
      applicationsApi.middleware,
      coursesApi.middleware,
    ]),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
